/**
 * @generated SignedSource<<5eb2e4459b08a2409aec5acbd1622b83>>
 * @relayHash c870c8661377f1f266e5bbc952da79fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 420b7bbeca9883e2ca518c3b4cd08d8e72e7c5d1853e2a7088ba52cc83986592

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  participants?: SearchParticipants | null | undefined;
  range?: SearchCommonRangeFilter | null | undefined;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null | undefined;
  lastModified?: SearchCommonRangeFilterFields | null | undefined;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null | undefined;
  containerARIs?: ReadonlyArray<string> | null | undefined;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null | undefined> | null | undefined;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null | undefined;
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  creatorsFilter?: ReadonlyArray<string> | null | undefined;
  isVerified?: boolean | null | undefined;
  labelsFilter?: ReadonlyArray<string> | null | undefined;
  mentions?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  pageStatus?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null | undefined> | null | undefined;
  spacesFilter?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null | undefined;
  issueFilter?: SearchJiraIssueFilter | null | undefined;
  projectFilter?: SearchJiraProjectFilter | null | undefined;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null | undefined;
  projectARI?: string | null | undefined;
  userARI?: string | null | undefined;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null | undefined;
  commenterARIs?: ReadonlyArray<string> | null | undefined;
  issueLabels?: ReadonlyArray<string> | null | undefined;
  issueTypeIDs?: ReadonlyArray<string> | null | undefined;
  issueTypes?: ReadonlyArray<string> | null | undefined;
  projectARIs?: ReadonlyArray<string> | null | undefined;
  reporterARIs?: ReadonlyArray<string> | null | undefined;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null | undefined;
  watcherARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null | undefined;
  projectTypes?: ReadonlyArray<SearchProjectType> | null | undefined;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null | undefined;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null | undefined;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null | undefined;
  focusAreaTypeIds?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null | undefined;
  focusAreas?: ReadonlyArray<string> | null | undefined;
  jobFamilies?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  statuses?: ReadonlyArray<string> | null | undefined;
  teams?: ReadonlyArray<string> | null | undefined;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null | undefined;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null | undefined;
  ancestorAris?: ReadonlyArray<string> | null | undefined;
  assignees?: ReadonlyArray<string> | null | undefined;
  containerAris?: ReadonlyArray<string> | null | undefined;
  containerNames?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  createdBy?: ReadonlyArray<string> | null | undefined;
  excludeSubtypes?: ReadonlyArray<string> | null | undefined;
  gitFilters?: SearchGitFilters | null | undefined;
  integrations?: ReadonlyArray<string> | null | undefined;
  labels?: ReadonlyArray<string> | null | undefined;
  lastUpdatedBy?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null | undefined> | null | undefined;
  salesforceFilters?: SearchSalesforceFilters | null | undefined;
  subtypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  teamsFilters?: SearchTeamsFilters | null | undefined;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null | undefined;
  thirdPartyTypes?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null | undefined;
  repoName?: ReadonlyArray<string> | null | undefined;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchSalesforceFilters = {
  closeDate?: string | null | undefined;
  isClosed?: boolean | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  stage?: ReadonlyArray<string> | null | undefined;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null | undefined;
  hasAttachment?: boolean | null | undefined;
  hasLink?: boolean | null | undefined;
};
export type SearchThirdPartyProduct = {
  connectionIds?: ReadonlyArray<string> | null | undefined;
  connectorSources?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  datasourceId?: string | null | undefined;
  entities?: ReadonlyArray<string> | null | undefined;
  integrationId?: string | null | undefined;
  linkedEntities?: ReadonlyArray<string> | null | undefined;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null | undefined;
  product?: string | null | undefined;
  providerId?: string | null | undefined;
  subtypes?: ReadonlyArray<string> | null | undefined;
};
export type SearchSortInput = {
  field: string;
  key?: string | null | undefined;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null | undefined> | null | undefined;
  layerId?: string | null | undefined;
  name?: string | null | undefined;
  shadowId?: string | null | undefined;
};
export type SearchLayerDefinition = {
  abTestId?: string | null | undefined;
  connectorSources?: ReadonlyArray<string | null | undefined> | null | undefined;
  entity?: string | null | undefined;
  integrationARI?: string | null | undefined;
  layerId?: string | null | undefined;
  providerId?: string | null | undefined;
  shadowId?: string | null | undefined;
  subEntity?: string | null | undefined;
};
export type searchResultsQuery$variables = {
  after?: string | null | undefined;
  assetsFilters?: SearchAssetsFilter | null | undefined;
  cloudIdARI: string;
  commonFilters?: SearchCommonFilter | null | undefined;
  compassFilters?: SearchCompassFilter | null | undefined;
  confluenceFilters?: SearchConfluenceFilter | null | undefined;
  disableQueryReplacement?: boolean | null | undefined;
  enableHighlighting?: boolean | null | undefined;
  entities: ReadonlyArray<string>;
  experience: string;
  experimentId?: string | null | undefined;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null | undefined> | null | undefined;
  fanoutExperimentCohort?: string | null | undefined;
  includeAssigneeField?: boolean | null | undefined;
  includeAutoAppliedFilters?: boolean | null | undefined;
  includeIconUrl?: boolean | null | undefined;
  includeIssueTypeField?: boolean | null | undefined;
  includeNavBoostScore?: boolean | null | undefined;
  includePassionfruitAsk?: boolean | null | undefined;
  includePositions?: boolean | null | undefined;
  includeThirdPartyId?: boolean | null | undefined;
  includeTotalCounts?: boolean | null | undefined;
  jiraFilters?: SearchJiraFilter | null | undefined;
  limit: number;
  mercuryFilters?: SearchMercuryFilter | null | undefined;
  query: string;
  queryVersion?: number | null | undefined;
  searchSessionId?: string | null | undefined;
  sessionId?: string | null | undefined;
  shadowExperimentId?: string | null | undefined;
  sort?: ReadonlyArray<SearchSortInput | null | undefined> | null | undefined;
  sourceProduct?: string | null | undefined;
  talentFilters?: SearchTalentFilter | null | undefined;
  tenantId: string;
  thirdPartyFilters?: SearchThirdPartyFilter | null | undefined;
};
export type searchResultsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsSyncInner_queryData">;
};
export type searchResultsQuery = {
  response: searchResultsQuery$data;
  variables: searchResultsQuery$variables;
};
({
  "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
  "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": isCustomerOrgOwnersEnabled_provider,
  "__relay_internal__pv__isdealownersenabledrelayprovider": isDealOwnersEnabled_provider
} as {
  readonly __relay_internal__pv__isassetsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__iscustomerorgownersenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isdealownersenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAssets_provider from './../is-assets-enabled.relayprovider';
import isCustomerOrgOwnersEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-customer-org/is-customer-org-owners-enabled.relayprovider';
import isDealOwnersEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-deal/is-deal-owners-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARI"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableHighlighting"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fanoutExperimentCohort"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAssigneeField"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutoAppliedFilters"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeIconUrl"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeIssueTypeField"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNavBoostScore"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePassionfruitAsk"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePositions"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeThirdPartyId"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeTotalCounts"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v35 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "queryVersion",
        "variableName": "queryVersion"
      },
      {
        "kind": "Variable",
        "name": "searchSessionId",
        "variableName": "searchSessionId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "sourceProduct",
        "variableName": "sourceProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "analytics"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  {
    "kind": "Variable",
    "name": "enableHighlighting",
    "variableName": "enableHighlighting"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "experimentId",
        "variableName": "experimentId"
      },
      {
        "kind": "Variable",
        "name": "experimentLayers",
        "variableName": "experimentLayers"
      },
      {
        "kind": "Variable",
        "name": "shadowExperimentId",
        "variableName": "shadowExperimentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "fanoutExperimentCohort",
    "variableName": "fanoutExperimentCohort"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "assetsFilters",
        "variableName": "assetsFilters"
      },
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "compassFilters",
        "variableName": "compassFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "jiraFilters",
        "variableName": "jiraFilters"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "locations.0",
            "variableName": "cloudIdARI"
          }
        ],
        "kind": "ListValue",
        "name": "locations"
      },
      {
        "kind": "Variable",
        "name": "mercuryFilters",
        "variableName": "mercuryFilters"
      },
      {
        "kind": "Variable",
        "name": "talentFilters",
        "variableName": "talentFilters"
      },
      {
        "kind": "Variable",
        "name": "thirdPartyFilters",
        "variableName": "thirdPartyFilters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  }
],
v36 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v37 = {
  "kind": "ScalarField",
  "name": "id"
},
v38 = {
  "kind": "ScalarField",
  "name": "description"
},
v39 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v40 = {
  "kind": "ScalarField",
  "name": "title"
},
v41 = {
  "kind": "ScalarField",
  "name": "url"
},
v42 = {
  "kind": "ScalarField",
  "name": "type"
},
v43 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v44 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v45 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v46 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v47 = {
  "kind": "ScalarField",
  "name": "value"
},
v48 = {
  "kind": "ScalarField",
  "name": "label"
},
v49 = [
  (v48/*: any*/)
],
v50 = {
  "kind": "ScalarField",
  "name": "key"
},
v51 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v52 = [
  (v51/*: any*/)
],
v53 = {
  "condition": "includeIconUrl",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v52/*: any*/)
},
v54 = {
  "kind": "ScalarField",
  "name": "name"
},
v55 = [
  (v54/*: any*/)
],
v56 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v57 = {
  "kind": "ScalarField",
  "name": "total"
},
v58 = {
  "kind": "ScalarField",
  "name": "count"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v60 = {
  "kind": "ScalarField",
  "name": "picture"
},
v61 = {
  "kind": "ScalarField",
  "name": "email"
},
v62 = [
  {
    "kind": "ScalarField",
    "name": "jobTitle"
  }
],
v63 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }
  ],
  "concreteType": "SocialSignalSearch",
  "kind": "LinkedField",
  "name": "socialSignal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "signal"
    },
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v36/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v54/*: any*/),
        (v60/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v61/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": (v62/*: any*/)
            }
          ],
          "type": "AtlassianAccountUser"
        },
        (v37/*: any*/)
      ]
    }
  ]
},
v64 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v55/*: any*/),
      "type": "ExternalRepository"
    },
    (v59/*: any*/)
  ]
},
v65 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v66 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v65/*: any*/),
        (v41/*: any*/),
        (v44/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    (v59/*: any*/)
  ]
},
v67 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v54/*: any*/),
    (v60/*: any*/),
    (v37/*: any*/)
  ]
},
v68 = [
  (v65/*: any*/)
],
v69 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v70 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v71 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": (v62/*: any*/)
},
v72 = [
  (v69/*: any*/),
  (v54/*: any*/),
  (v70/*: any*/),
  (v61/*: any*/),
  (v60/*: any*/),
  (v71/*: any*/),
  (v37/*: any*/)
],
v73 = {
  "concreteType": "ExternalAssociationConnection",
  "kind": "LinkedField",
  "name": "associatedWith",
  "plural": false,
  "selections": [
    {
      "concreteType": "ExternalAssociationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ExternalAssociation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v36/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v72/*: any*/),
                  "type": "ThirdPartyUser"
                },
                (v59/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "channelId",
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    (v65/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            (v37/*: any*/)
          ]
        }
      ]
    }
  ]
},
v74 = {
  "kind": "ScalarField",
  "name": "thumbnailUrl"
},
v75 = [
  (v37/*: any*/),
  (v54/*: any*/),
  (v61/*: any*/),
  (v60/*: any*/),
  (v69/*: any*/),
  (v71/*: any*/)
],
v76 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v75/*: any*/)
    }
  ]
},
v77 = [
  (v37/*: any*/),
  (v54/*: any*/)
],
v78 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v77/*: any*/)
},
v79 = [
  (v78/*: any*/)
],
v80 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v79/*: any*/)
},
v81 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v82 = {
  "kind": "ScalarField",
  "name": "status"
},
v83 = [
  (v54/*: any*/),
  (v37/*: any*/)
],
v84 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": (v83/*: any*/)
  }
],
v85 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": (v84/*: any*/)
},
v86 = [
  (v85/*: any*/)
],
v87 = {
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v37/*: any*/),
        (v65/*: any*/)
      ],
      "type": "ExternalCustomerOrg"
    },
    (v59/*: any*/)
  ]
},
v88 = [
  {
    "kind": "ScalarField",
    "name": "lastActivityAt"
  },
  {
    "kind": "ScalarField",
    "name": "event"
  }
],
v89 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v79/*: any*/)
},
v90 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v79/*: any*/)
},
v91 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v92 = [
  (v36/*: any*/),
  (v54/*: any*/),
  (v37/*: any*/)
],
v93 = {
  "kind": "ScalarField",
  "name": "workspaceName"
},
v94 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v95 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v96 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v97 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
},
v98 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": (v72/*: any*/)
},
v99 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": [
    (v54/*: any*/),
    (v70/*: any*/),
    (v61/*: any*/),
    (v60/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/),
    (v37/*: any*/)
  ]
},
v100 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v101 = [
  (v43/*: any*/),
  (v51/*: any*/)
],
v102 = [
  {
    "kind": "ScalarField",
    "name": "targetDate"
  },
  {
    "kind": "ScalarField",
    "name": "targetDateType"
  }
],
v103 = [
  (v43/*: any*/)
],
v104 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v105 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "objectSchemaEntity",
  "plural": false,
  "selections": (v83/*: any*/)
},
v106 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v107 = [
  (v50/*: any*/),
  (v37/*: any*/)
],
v108 = {
  "kind": "ScalarField",
  "name": "product"
},
v109 = {
  "kind": "ScalarField",
  "name": "combination"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "includeAssigneeField",
            "variableName": "includeAssigneeField"
          },
          {
            "kind": "Variable",
            "name": "includeAutoAppliedFilters",
            "variableName": "includeAutoAppliedFilters"
          },
          {
            "kind": "Variable",
            "name": "includeIconUrl",
            "variableName": "includeIconUrl"
          },
          {
            "kind": "Variable",
            "name": "includeIssueTypeField",
            "variableName": "includeIssueTypeField"
          },
          {
            "kind": "Variable",
            "name": "includeNavBoostScore",
            "variableName": "includeNavBoostScore"
          },
          {
            "kind": "Variable",
            "name": "includePassionfruitAsk",
            "variableName": "includePassionfruitAsk"
          },
          {
            "kind": "Variable",
            "name": "includePositions",
            "variableName": "includePositions"
          },
          {
            "kind": "Variable",
            "name": "includeThirdPartyId",
            "variableName": "includeThirdPartyId"
          },
          {
            "kind": "Variable",
            "name": "includeTotalCounts",
            "variableName": "includeTotalCounts"
          }
        ],
        "kind": "FragmentSpread",
        "name": "searchResults_AtlassianSearchPage_SearchResultsSyncInner_queryData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v25/*: any*/),
      (v2/*: any*/),
      (v33/*: any*/),
      (v23/*: any*/),
      (v8/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v22/*: any*/),
      (v1/*: any*/),
      (v24/*: any*/),
      (v32/*: any*/),
      (v4/*: any*/),
      (v34/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v10/*: any*/),
      (v29/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v19/*: any*/),
      (v13/*: any*/),
      (v20/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v21/*: any*/),
      (v16/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isassetsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "searchResultsQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "args": (v35/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      {
                        "concreteType": "SearchLinkedResult",
                        "kind": "LinkedField",
                        "name": "linkedResults",
                        "plural": true,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          },
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v38/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/)
                        ]
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isSearchResult"
                      },
                      (v40/*: any*/),
                      (v42/*: any*/),
                      (v41/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareLocalizationField",
                                    "kind": "LinkedField",
                                    "name": "localizedLabel",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "messageId"
                                      }
                                    ]
                                  },
                                  (v47/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v49/*: any*/)
                              },
                              (v37/*: any*/),
                              (v50/*: any*/),
                              (v38/*: any*/)
                            ]
                          },
                          (v53/*: any*/)
                        ],
                        "type": "SearchResultAtlasGoal"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "dueDate",
                                "plural": false,
                                "selections": (v49/*: any*/)
                              },
                              {
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v47/*: any*/)
                                ]
                              },
                              (v37/*: any*/),
                              (v50/*: any*/)
                            ]
                          },
                          (v53/*: any*/)
                        ],
                        "type": "SearchResultAtlasProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "SearchFederatedEmailUser",
                                    "kind": "LinkedField",
                                    "name": "sender",
                                    "plural": false,
                                    "selections": (v55/*: any*/)
                                  }
                                ],
                                "type": "SearchFederatedEmailEntity"
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultFederated"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "tier"
                          },
                          {
                            "concreteType": "CompassComponent",
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              (v37/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "ownerId"
                          }
                        ],
                        "type": "SearchResultCompassComponent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v56/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          },
                          {
                            "concreteType": "SearchConfluenceResultSpace",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              (v54/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUiLink"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/),
                                  {
                                    "concreteType": "ConfluenceCommentCountSummary",
                                    "kind": "LinkedField",
                                    "name": "commentCountSummary",
                                    "plural": false,
                                    "selections": [
                                      (v57/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ConfluenceLikesSummary",
                                    "kind": "LinkedField",
                                    "name": "likesSummary",
                                    "plural": false,
                                    "selections": [
                                      (v58/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              (v59/*: any*/)
                            ]
                          },
                          (v63/*: any*/),
                          (v53/*: any*/),
                          {
                            "condition": "includeNavBoostScore",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "navBoostScore"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v56/*: any*/),
                          (v53/*: any*/)
                        ],
                        "type": "SearchConfluenceSpace"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v46/*: any*/),
                          (v39/*: any*/),
                          (v45/*: any*/),
                          (v44/*: any*/),
                          (v43/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "permissionLevel"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v54/*: any*/),
                                  (v64/*: any*/)
                                ],
                                "type": "ExternalBranch"
                              },
                              (v59/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v66/*: any*/)
                                ],
                                "type": "ExternalComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v67/*: any*/)
                                    ]
                                  },
                                  (v64/*: any*/)
                                ],
                                "type": "ExternalCommit"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v36/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v65/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "type": "ExternalSpace"
                                      },
                                      (v59/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalReaction",
                                    "kind": "LinkedField",
                                    "name": "reactions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "reactionType"
                                      },
                                      (v57/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "includeThirdPartyId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalDocumentType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": (v52/*: any*/)
                                  },
                                  {
                                    "concreteType": "ExternalLargeContent",
                                    "kind": "LinkedField",
                                    "name": "nonIndexableContent",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "mediaThumbnailUrl"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v36/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v68/*: any*/),
                                        "type": "ExternalDocument"
                                      },
                                      (v59/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v69/*: any*/),
                                  (v73/*: any*/),
                                  (v38/*: any*/),
                                  {
                                    "concreteType": "ExternalAttachment",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": true,
                                    "selections": [
                                      (v40/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "mimeType"
                                      },
                                      (v41/*: any*/),
                                      (v74/*: any*/),
                                      (v36/*: any*/)
                                    ]
                                  },
                                  (v76/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v36/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v65/*: any*/),
                                          (v80/*: any*/),
                                          (v42/*: any*/),
                                          (v37/*: any*/),
                                          (v81/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "membershipType"
                                          }
                                        ],
                                        "type": "ExternalConversation"
                                      },
                                      (v59/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastActive"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "reactionCount"
                                  }
                                ],
                                "type": "ExternalMessage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v38/*: any*/),
                                  (v65/*: any*/),
                                  (v81/*: any*/),
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                      (v36/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalConversation"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v82/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdated"
                                  },
                                  (v85/*: any*/),
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": (v84/*: any*/)
                                  }
                                ],
                                "type": "ExternalCampaign"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v65/*: any*/),
                                  {
                                    "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "contributors",
                                        "plural": true,
                                        "selections": (v79/*: any*/)
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v86/*: any*/)
                                  },
                                  (v87/*: any*/),
                                  {
                                    "concreteType": "ExternalCustomerOrgLastActivity",
                                    "kind": "LinkedField",
                                    "name": "customerOrgLastActivity",
                                    "plural": false,
                                    "selections": (v88/*: any*/)
                                  }
                                ],
                                "type": "ExternalCustomerOrg"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "stage"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dealClosedAt"
                                  },
                                  {
                                    "concreteType": "ExternalDealLastActivity",
                                    "kind": "LinkedField",
                                    "name": "lastActivity",
                                    "plural": false,
                                    "selections": (v88/*: any*/)
                                  },
                                  {
                                    "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v86/*: any*/)
                                  },
                                  (v87/*: any*/)
                                ],
                                "type": "ExternalDeal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v66/*: any*/),
                                  (v89/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/),
                                  (v50/*: any*/),
                                  (v82/*: any*/)
                                ],
                                "type": "ExternalProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v66/*: any*/),
                                  (v89/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/),
                                  (v82/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "team"
                                  },
                                  {
                                    "concreteType": "ExternalWorkItemProject",
                                    "kind": "LinkedField",
                                    "name": "workItemProject",
                                    "plural": false,
                                    "selections": (v77/*: any*/)
                                  }
                                ],
                                "type": "ExternalWorkItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "pullRequestId"
                                  },
                                  {
                                    "alias": "pullRequestStatus",
                                    "kind": "ScalarField",
                                    "name": "status"
                                  },
                                  (v64/*: any*/)
                                ],
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "durationInSeconds"
                                  },
                                  (v74/*: any*/),
                                  {
                                    "concreteType": "ExternalChapter",
                                    "kind": "LinkedField",
                                    "name": "chapters",
                                    "plural": true,
                                    "selections": [
                                      (v40/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                      (v78/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v92/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v41/*: any*/),
                                  (v93/*: any*/),
                                  (v85/*: any*/)
                                ],
                                "type": "ExternalDashboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v41/*: any*/),
                                  {
                                    "alias": "dataTableType",
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v93/*: any*/),
                                  (v85/*: any*/)
                                ],
                                "type": "ExternalDataTable"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "accountName"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "contactUser",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                          (v54/*: any*/),
                                          (v71/*: any*/),
                                          (v37/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalCustomerContact"
                              }
                            ]
                          },
                          (v94/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v90/*: any*/),
                                  (v95/*: any*/),
                                  (v96/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "recurringEventId"
                                  },
                                  (v97/*: any*/)
                                ],
                                "type": "ExternalCalendarEvent"
                              },
                              (v59/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalThumbnail",
                                    "kind": "LinkedField",
                                    "name": "thumbnail",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalDesign"
                              }
                            ]
                          },
                          {
                            "concreteType": "SearchResultGraphDocument",
                            "kind": "LinkedField",
                            "name": "linkedEntities",
                            "plural": true,
                            "selections": [
                              (v37/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v96/*: any*/),
                                      (v95/*: any*/),
                                      (v97/*: any*/)
                                    ],
                                    "type": "ExternalCalendarEvent"
                                  },
                                  (v59/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v68/*: any*/),
                                    "type": "ExternalComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v76/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v80/*: any*/),
                                              (v42/*: any*/)
                                            ],
                                            "type": "ExternalConversation"
                                          },
                                          (v59/*: any*/)
                                        ]
                                      },
                                      (v69/*: any*/),
                                      (v73/*: any*/),
                                      (v38/*: any*/)
                                    ],
                                    "type": "ExternalMessage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v38/*: any*/)
                                    ],
                                    "type": "ExternalConversation"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "parentId"
                              },
                              (v94/*: any*/),
                              {
                                "concreteType": "ThirdPartyUser",
                                "kind": "LinkedField",
                                "name": "initialContributors",
                                "plural": true,
                                "selections": (v75/*: any*/)
                              },
                              (v98/*: any*/),
                              (v45/*: any*/),
                              (v99/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "ThirdPartyUser",
                            "kind": "LinkedField",
                            "name": "initialContributors",
                            "plural": true,
                            "selections": [
                              (v54/*: any*/),
                              (v60/*: any*/),
                              (v37/*: any*/),
                              (v61/*: any*/),
                              (v69/*: any*/),
                              (v71/*: any*/)
                            ]
                          },
                          (v98/*: any*/),
                          {
                            "concreteType": "SearchResultGraphAttachment",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "fileType"
                              },
                              (v41/*: any*/),
                              (v36/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "containerName"
                          },
                          (v99/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "links"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "linkedEntitiesType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "connectorId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "connectorProduct"
                          }
                        ],
                        "type": "SearchResultGraphDocument"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          (v51/*: any*/),
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeAvatarUrl"
                              },
                              (v100/*: any*/),
                              (v50/*: any*/),
                              {
                                "condition": "includeIssueTypeField",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": (v83/*: any*/)
                                      },
                                      (v37/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                      "project"
                                    ]
                                  }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v54/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": (v77/*: any*/)
                                              }
                                            ],
                                            "type": "JiraProjectField"
                                          },
                                          (v37/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "fieldsById(ids:[\"project\"])"
                              },
                              {
                                "condition": "includeAssigneeField",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "assigneeField",
                                    "plural": false,
                                    "selections": [
                                      (v67/*: any*/),
                                      (v37/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v37/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "projectKey"
                          },
                          (v43/*: any*/),
                          (v51/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v100/*: any*/),
                              (v37/*: any*/)
                            ]
                          },
                          (v63/*: any*/)
                        ],
                        "type": "SearchResultJiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v101/*: any*/),
                        "type": "SearchResultJiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          (v51/*: any*/),
                          {
                            "concreteType": "JiraBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                              (v51/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "boardFrontendUrl"
                              },
                              (v37/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v101/*: any*/),
                        "type": "SearchResultJiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v101/*: any*/),
                        "type": "SearchResultJiraFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MercuryFocusAreaStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v50/*: any*/),
                                  (v65/*: any*/),
                                  (v37/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryFocusAreaHealth",
                                "kind": "LinkedField",
                                "name": "health",
                                "plural": false,
                                "selections": [
                                  (v50/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "color"
                                  },
                                  (v65/*: any*/),
                                  (v37/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v102/*: any*/)
                              },
                              (v37/*: any*/),
                              (v54/*: any*/),
                              {
                                "concreteType": "MercuryFocusAreaType",
                                "kind": "LinkedField",
                                "name": "focusAreaType",
                                "plural": false,
                                "selections": (v77/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": (v92/*: any*/)
                              }
                            ]
                          },
                          (v43/*: any*/)
                        ],
                        "type": "SearchResultMercuryFocusArea"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": (v83/*: any*/)
                          }
                        ],
                        "type": "SearchResultMercuryFocusAreaStatusUpdate"
                      },
                      {
                        "condition": "includePassionfruitAsk",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "SpfAsk",
                                "kind": "LinkedField",
                                "name": "ask",
                                "plural": false,
                                "selections": [
                                  (v82/*: any*/),
                                  {
                                    "concreteType": "SpfAskTargetDate",
                                    "kind": "LinkedField",
                                    "name": "targetDate",
                                    "plural": false,
                                    "selections": (v102/*: any*/)
                                  },
                                  (v37/*: any*/)
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "type": "SearchResultSpfAsk"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v103/*: any*/),
                        "type": "SearchResultTrelloBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v103/*: any*/),
                        "type": "SearchResultTrelloCard"
                      },
                      {
                        "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              {
                                "concreteType": "AssetsSchema",
                                "kind": "LinkedField",
                                "name": "objectSchemaEntity",
                                "plural": false,
                                "selections": [
                                  (v104/*: any*/),
                                  (v37/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectSchema"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v105/*: any*/),
                              {
                                "concreteType": "AssetsObjectType",
                                "kind": "LinkedField",
                                "name": "objectTypeEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": (v106/*: any*/)
                                  },
                                  (v104/*: any*/),
                                  (v37/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v105/*: any*/),
                              {
                                "concreteType": "AssetsObject",
                                "kind": "LinkedField",
                                "name": "objectEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": (v106/*: any*/)
                                  },
                                  (v104/*: any*/),
                                  (v37/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObject"
                          }
                        ]
                      },
                      {
                        "condition": "includePositions",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "RadarPosition",
                                "kind": "LinkedField",
                                "name": "position",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  {
                                    "concreteType": "RadarWorker",
                                    "kind": "LinkedField",
                                    "name": "worker",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v60/*: any*/),
                                          (v37/*: any*/)
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                          "positionId",
                                          "positionStatus",
                                          "positionJobTitle",
                                          "positionPositionTitle",
                                          "positionKey",
                                          "positionExternalPositionKey",
                                          "positionWorker",
                                          "focusArea"
                                        ]
                                      }
                                    ],
                                    "concreteType": "RadarFieldValueIdPair",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "stringValue",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              }
                                            ],
                                            "type": "RadarStringFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "value",
                                                "plural": false,
                                                "selections": [
                                                  (v36/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v54/*: any*/),
                                                      {
                                                        "concreteType": "MercuryFocusAreaStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": (v107/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "MercuryFocusAreaHealth",
                                                        "kind": "LinkedField",
                                                        "name": "health",
                                                        "plural": false,
                                                        "selections": (v107/*: any*/)
                                                      }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                  },
                                                  (v59/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "RadarAriFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                  },
                                  (v37/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultTalentPosition"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "originalQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "replacementQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "suggestedQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "originalQueryType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "confidenceScore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldTriggerAutocorrectionExperience"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "traceId"
              },
              {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  (v108/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "integration"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "condition": "includeAutoAppliedFilters",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "SearchFilterOutput",
                    "kind": "LinkedField",
                    "name": "autoAppliedFilters",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "SearchCommonFilterOutput",
                        "kind": "LinkedField",
                        "name": "commonFilters",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "SearchCommonRangeFilterOutput",
                            "kind": "LinkedField",
                            "name": "range",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "SearchCommonRangeFilterFieldsOutput",
                                "kind": "LinkedField",
                                "name": "lastModified",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "gt"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lt"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "SearchParticipantsOutput",
                            "kind": "LinkedField",
                            "name": "participants",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "SearchParticipantOutput",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v42/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "users"
                                  },
                                  (v109/*: any*/)
                                ]
                              },
                              (v109/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeTotalCounts",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "SearchProductCount",
                    "kind": "LinkedField",
                    "name": "totalCounts",
                    "plural": true,
                    "selections": [
                      (v108/*: any*/),
                      (v58/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v35/*: any*/),
            "filters": [
              "experience",
              "enableHighlighting",
              "query",
              "sort",
              "disableQueryReplacement",
              "fanoutExperimentCohort",
              "filters",
              "analytics",
              "experimentContext"
            ],
            "handle": "connection",
            "key": "SearchResultsPagination__search",
            "kind": "LinkedHandle",
            "name": "search"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "420b7bbeca9883e2ca518c3b4cd08d8e72e7c5d1853e2a7088ba52cc83986592",
    "metadata": {},
    "name": "searchResultsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
      "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": isCustomerOrgOwnersEnabled_provider,
      "__relay_internal__pv__isdealownersenabledrelayprovider": isDealOwnersEnabled_provider
    }
  }
};
})();

(node as any).hash = "e9592471d67444bb8ca9d3af3e7b4223";

export default node;
